import {call, put, takeLatest} from 'redux-saga/effects';
import actions from './actions';


function* sendAction() {
    yield put({type: actions.UPDATE_LAST_ACTION_TIMESTAMP})
}

export default function* activitySaga() {
    yield takeLatest(action => /^RA/.test(action.type), sendAction);
}